var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.gender != null || _vm.gender != undefined)?_c('v-icon',{staticClass:"mr-2",attrs:{"color":_vm.gender || _vm.gender == 1 ? 'blue' : 'pink'}},[_vm._v(" "+_vm._s(_vm.gender || _vm.gender == 1 ? "mdi-human-male" : "mdi-human-female"))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }